import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { site } from '../config/site';
import { joinUrl } from '../lib/urls';

type SeoProps = {
  title: string;
  description: string;
  canonicalPath?: string;
  imagePath?: string;
  noIndex?: boolean;
  jsonLd?: Record<string, unknown> | Array<Record<string, unknown>>;
};

export function Seo({
  title,
  description,
  canonicalPath,
  imagePath = '/images/logo.webp',
  noIndex,
  jsonLd,
}: SeoProps) {
  const location = useLocation();
  const canonical = joinUrl(site.url, canonicalPath ?? location.pathname);
  const imageUrl = joinUrl(site.url, imagePath);
  const fullTitle = `${title} — ${site.name}`;

  const jsonLdArray = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <html lang="fr" />
      <title>{fullTitle}</title>
      <link rel="canonical" href={canonical} />
      <meta name="description" content={description} />
      <meta name="theme-color" content="#07070A" />
      <meta property="og:site_name" content={site.name} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {noIndex ? <meta name="robots" content="noindex,nofollow" /> : null}
      {jsonLdArray.map((obj, idx) => (
        <script key={idx} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}


